module.exports = __webpack_public_path__ + "YSIIconA-3ffcb5d85c69f5cb946831e8304ccce7.svg";